import html from '../assets/html.png'
import css from '../assets/css.png'
import js from '../assets/javascript.png'
import react from '../assets/react.png'
import tailwind from '../assets/tailwind.png'
import git from '../assets/git.png'
import redux from '../assets/redux.png'
import rest from '../assets/api.png'

export const skills=[{
    id:1,
    title:'HTML5',
    image:html
},
{
    id:2,
    title:'CSS3',
    image:css
},
{
    id:3,
    title:'Javascript',
    image:js
},
{
    id:4,
    title:'React',
    image:react
},
{
    id:5,
    title:'Tailwind CSS',
    image:tailwind
},
{
    id:6,
    title:'Git',
    image:git
},
{
    id:7,
    title:'REST API',
    image:rest
},
{
    id:8,
    title:'Redux',
    image:redux
}
]
